import React, { createContext, useReducer } from 'react'

export const GlobalMusicContext = createContext()
const initialState = {
  searchState: 'home',
  searchResults: [],
  relatedTracks: [],
  currentTrack: {},
  repeat: false,
  random: false
}

const reducer = ( state, action ) => {
  switch ( action.type ) {
    case 'setSearchState': {
      return {
        ...state,
        searchState: action.snippet
      }
    }
    case 'setSearchResults': {
      return {
        ...state,
        searchResults: action.snippet
      }
    }
    case 'setCurrentTrack': {
      return {
        ...state,
        currentTrack: action.snippet
      }
    }
    case 'setRelatedTracks': {
      return {
        ...state,
        relatedTracks: action.snippet
      }
    }
    case 'TOGGLE_REPEAT':
      return {
        ...state,
        repeat: action.data
      }
    case 'TOGGLE_RANDOM':
      return {
        ...state,
        random: action.data
      }
    default:
      return state
  }
}

export const GlobalMusicProvider = ( props ) => {
  const globalState = useReducer( reducer, initialState )
  // console.log( globalState, "GlobalMusicProvider" )
  return (
    <GlobalMusicContext.Provider value={globalState}>
      {props.children}
    </GlobalMusicContext.Provider>
  )
}